import React from 'react';
import { ZapOff, Info } from 'lucide-react'; // Using the 'ZapOff' icon

import Modal from '../base/Modal';

const LoopBreakNodeModal = ({ mode, node, onSave, onDelete, onClose }) => {
  const handleSave = () => {
    onSave({
      ...node,
      data: {
        label: 'Loop Break',
      },
    });
  };

  return (
    <Modal title="Configure Loop Break Node" isOpen={true} onClose={onClose}>
      <div className="rounded-b-lg bg-zinc-900 p-6 text-center">
        <div className="mb-5 flex items-center justify-center">
          <div className="rounded-full bg-zinc-800 p-4">
            <ZapOff className="h-12 w-12 text-rose-400" />
          </div>
        </div>

        <h3 className="mb-2 text-xl font-semibold text-white">
          Loop Break Point
        </h3>
        <p className="mx-auto mb-6 max-w-sm text-zinc-400">
          This node stops a loop from an "Unwrap Array" node by merging its
          parallel branches back into a single path.
        </p>

        <div className="flex items-start gap-3 rounded-lg border border-zinc-700 bg-zinc-800/50 p-3 text-left">
          <Info className="mt-0.5 h-5 w-5 shrink-0 text-zinc-500" />
          <p className="text-sm text-zinc-400">
            This control node does not produce any data output.
          </p>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          {mode === 'edit' && (
            <button
              className="rounded-md bg-red-800 px-4 py-2 text-zinc-300 transition-colors hover:bg-red-700"
              onClick={() => onDelete(node.id)}
            >
              Delete Node
            </button>
          )}
          {mode === 'add' && (
            <button
              className="rounded-md bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700"
              onClick={handleSave}
            >
              Add Node
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default LoopBreakNodeModal;
